import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Categorias } from '../models/Categorias';

export class CategoriaService {
  
  // Obtener todos los roles
  static async getAllCa(id) {
    try {
      // console.log('🔍 === GETALLROLES DEBUG ===');
      // console.log('🔍 URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.ROLES);
      
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.CATEGORIA}/sucursal/${id}`);
      
      // console.log('✅ Respuesta cruda del API:', response.data);
      // console.log('✅ Tipo de response.data:', typeof response.data);
      // console.log('✅ Keys de response.data:', Object.keys(response.data));
      
      // ✅ MANEJO ESPECÍFICO PARA TU FORMATO DE API
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data; // Tu formato: {success: true, data: [...]}
        //console.log('✅ Usando response.data.data (formato success/data)');
      } else if (Array.isArray(response.data)) {
        Data = response.data; // Formato directo: [...]
        //console.log('✅ Usando response.data (formato array directo)');
      } else {
        //console.error('❌ Formato de API no reconocido:', response.data);
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      // console.log('✅ Datos extraídos:', rolesData);
      // console.log('✅ Es array?', Array.isArray(rolesData));
      // console.log('✅ Cantidad de elementos:', rolesData.length);
      
      if (!Array.isArray(Data)) {
        //console.error('❌ rolesData no es array:', rolesData);
        throw new Error('Los datos recibidos no son un array');
      }
      
      // ✅ MAPEAR CADA ROL Y MOSTRAR DEBUG
      const mapped = Data.map((rData, index) => {
        //console.log(`🔍 Mapeando rol ${index}:`, roleData);
        const data = new Categorias(rData);
        //console.log(`✅ Rol mapeado ${index}:`, data.toDebug());
        return data;
      });
      
      //console.log('✅ TODOS LOS ROLES MAPEADOS:', mapped);
      return mapped;
      
    } catch (error) {
      console.error('❌ === ERROR GETALLROLES ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Status Text:', error.response.statusText);
        console.error('❌ Data:', error.response.data);
        console.error('❌ Headers:', error.response.headers);
      }
      
      throw new Error('Error al obtener Categoria: ' + error.message);
    }
  }

  // Obtener rol por ID
  static async getById(id) {
    try {
      //console.log('🔍 Obteniendo rol ID:', id);
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.CATEGORIA}/sucursal/${id}`);
      console.log('✅ Categoria obtenido:', response.data);
      
      const rData = response.data.data || response.data;
      return new Categorias(rData);
    } catch (error) {
      console.error('❌ Error obteniendo Categoria:', error);
      throw new Error('Error al obtener el Categoria');
    }
  }

  // Crear nuevo rol
  static async create(Data) {
    try {
      const data = new Categorias(Data);
      //const apiData = data.toApiFormat()
      console.log('🔍 Creando Categoria:', data.toCreateFormat());
      
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.CATEGORIA, data.toCreateFormat());
      console.log('✅ Categoria creado:', response.data);
      
      const createdData = response.data.data || response.data;
      return new Categorias(createdData);
    } catch (error) {
      console.error('❌ Error creando Categoria:', error);
      throw new Error('Error al crear el Categoria');
    }
  }

  // Actualizar rol
  static async update(id, Data) {
    try {
      console.log('🔍 === UPDATE DEBUG ===');
      console.log('🔍 ID:', id);
      console.log('🔍 Data:', Data);
      
      if (!id) {
        throw new Error('ID de Categoria no proporcionado');
      }
      
      let data;
      if (Data instanceof Categorias) {
        data = Data;
      } else {
        data = new Categorias(Data);
      }
      
      const dataToSend = data.toApiFormat();
      console.log('********* 🔍 Data convertido a formato API (minúsculas):', dataToSend);
      
      const response = await apiClient.put(`${API_CONFIG.ENDPOINTS.CATEGORIA}/${id}`, dataToSend);
      //console.log('✅ Role actualizado:', response.data);
      
      const updatedData = response.data.data || response.data;
      return new Categorias(updatedData);
      
    } catch (error) {
      console.error('❌ Error actualizando Categoria:', error);
      throw new Error('Error al actualizar el Categoria');
    }
  }

  static async deleteRole(id) {
    try {
      console.log('🔍 Eliminando Categoria ID:', id);
      await apiClient.delete(`${API_CONFIG.ENDPOINTS.CATEGORIA}/${id}`);
      console.log('✅ Categoria eliminado exitosamente');
      return true;
    } catch (error) {
      console.error('❌ Error eliminando Categoria:', error);
      throw new Error('Error al eliminar el Categoria');
    }
  }

  // MÉTODO DE PRUEBA
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.CATEGORIA);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.CATEGORIA);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.CATEGORIA);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}